module.exports = __webpack_public_path__ + "assets/img/IMG014.f7793b21.png";